module.exports = __webpack_public_path__ + "img/undraw_empty_xct9.6fef9673.svg";